// Array of all weekdays in order (Monday to Sunday) with derived type
export const weekdays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const;

export type Weekdays = typeof weekdays;
